export const environment = {
  production: false,
  adminEmail: 'auragroups8@gmail.com',
  firebaseConfig: {
     apiKey: "AIzaSyBcLfcXrFHkvH30p3c6aK_2cDFNU4QQSbg",
  authDomain: "aura94-86820.firebaseapp.com",
  projectId: "aura94-86820",
  storageBucket: "aura94-86820.firebasestorage.app",
  messagingSenderId: "934778894789",
  appId: "1:934778894789:web:beacb2672aebbbe8cc33ac"
  },
  cloudinary: {
    cloudName: 'byjxpk4d',
    uploadPreset: 'aura_unsigned_preset'
  }
};
